import React from 'react';
import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/client';

import './assets/css/fonts.css';

import './assets/css/reset.css'
import './assets/css/style_menu.css'
import './assets/css/style_menuadd.css'
import './assets/css/bootstrap-4.3.1.css'
import './assets/css/bootstrap-grid.css'
import './assets/css/bootstrap-grid.css.map'
import './assets/css/bootstrap.min.css.map'
import './assets/css/bootstrap.min.css'
import './assets/css/bootstrap.css.map'
import './assets/css/bootstrap.css'
import './assets/css/bootstrap-reboot.min.css.map'
import './assets/css/bootstrap-reboot.min.css'
import './assets/css/bootstrap-reboot.css.map'
import './assets/css/bootstrap-reboot.css'
import './assets/css/cecabank.css'
import ConexState from './context/ConexState';
import Router from './Router';

ReactDOM.render( 
     <React.StrictMode>
      <ConexState>
        <Router/>
      </ConexState>
     </React.StrictMode>,
  document.getElementById('root')
  );
